module.exports = __webpack_public_path__ + "7028459072cdea1a05ef99fc33f4d9cf.png";